export default __webpack_public_path__ + "static/media/shape_1.8b7ddb56.svg";